import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PracticesListPage } from './practices-list.page';

const routes: Routes = [
  {
    path: '',
    component: PracticesListPage
  },
  {
    path: 'edit-community/:type/:id',
    loadChildren: () =>
      import('../community/edit-community/edit-community.module').then(
        (m) => m.EditCommunityPageModule
      ),
    data: {
      breadcrumb: 'COMMUNITY.DETAIL_COMMUNITY',
    },
  },
  {
    path: 'detail-community/:id',
    loadChildren: () =>
      import('../community/detail-community/detail-community.module').then(
        (m) => m.DetailCommunityPageModule
      ),
    data: {
      breadcrumb: 'COMMUNITY.POST',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PracticesListPageRoutingModule {}
